<template>
  <svg
    fill="#000000"
    version="1.1"
    id="Layer_1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 485.61 485.61"
    xml:space="preserve"
  >
    <g id="XMLID_918_">
      <g>
        <g>
          <path
            d="M366.781,73.842c-12.021,0-23.321,4.681-31.82,13.18c-17.546,17.545-17.546,46.094,0,63.639
				c8.499,8.5,19.8,13.181,31.82,13.181s23.32-4.681,31.819-13.181c17.546-17.545,17.546-46.094,0-63.639
				C390.101,78.522,378.801,73.842,366.781,73.842z M377.388,129.448c-2.833,2.833-6.601,4.394-10.606,4.394
				c-4.007,0-7.774-1.561-10.607-4.394c-5.849-5.849-5.849-15.365,0-21.213c2.833-2.833,6.601-4.393,10.607-4.393
				s7.773,1.56,10.606,4.393C383.236,114.083,383.236,123.6,377.388,129.448z"
          />
          <path
            d="M472.704,21.533l-2.393-6.223l-6.224-2.393C441.801,4.346,418.406,0,394.556,0c-50.711,0-98.243,19.604-133.841,55.202
				l-44.928,44.927l-113.138,14.142l-83.364,83.364l70.711,28.285l-15.734,15.735l22.835,22.835l-35.355,49.497l109.895,109.895
				l49.497-35.356l22.835,22.835l15.734-15.735l28.284,70.711l83.364-83.364l14.141-113.136l44.928-44.929
				C483.287,172.04,499.885,92.21,472.704,21.533z M72.67,186.679l43.915-43.916l64.65-8.081l-68.159,68.159L72.67,186.679z
				 M174.878,384.698l-73.953-73.954l17.677-24.748l81.025,81.024L174.878,384.698z M342.858,369.038l-43.915,43.915l-16.163-40.406
				l68.159-68.159L342.858,369.038z M409.208,203.694l-165.24,165.24L190.934,315.9l116.673-116.672l-21.213-21.213L169.721,294.688
				l-53.033-53.033l165.24-165.24C311.859,46.484,351.858,30,394.556,30c17.909,0,35.516,2.9,52.435,8.63
				C466.615,96.637,452.134,160.768,409.208,203.694z"
          />
          <rect
            x="44.257"
            y="396.362"
            transform="matrix(0.7071 -0.7071 0.7071 0.7071 -269.1277 172.9926)"
            width="59.999"
            height="30"
          />

          <rect
            x="101.686"
            y="423.791"
            transform="matrix(-0.7071 -0.7071 0.7071 -0.7071 -121.683 857.1786)"
            width="30"
            height="59.999"
          />
          <rect
            x="1.835"
            y="353.93"
            transform="matrix(0.7071 -0.7071 0.7071 0.7071 -251.5493 130.5676)"
            width="59.999"
            height="30"
          />
        </g>
      </g>
    </g>
  </svg>
</template>

<script>
export default {
  name: "IconRocket"
};
</script>
